export default('formatDate', datetime => ("0" + (datetime.getMonth() + 1)).slice(-2) + "/" + ("0" + datetime.getDate()).slice(-2) + "/" + ("" + datetime.getFullYear()).slice(-2));
